<template>
  <div>
    <b-container class="bv-example-row">
      <div class="mt-15 container card_container">
        <h3 class="mb-5 titolo"><i class="fas fa-user"></i> Accesso con Spid/CIE</h3>
        <b-container class="bv-example-row">
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px"><strong>Nome</strong></div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="nome"
                placeholder="Nome"
                :value="jsonData.nome"
                style="text-transform: uppercase"
                disabled
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Cognome</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="cognome"
                placeholder="Cognome"
                :value="jsonData.cognome"
                style="text-transform: uppercase"
                disabled
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Codice fiscale</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="cf"
                placeholder="Codice Fiscale"
                :value="jsonData.codiceFiscale"
                style="text-transform: uppercase"
                disabled
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px"><strong>Data di nascita</strong></div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="datanascita"
                placeholder="Data di nascita"
                :value="jsonData.dataNascita"
                locale="it"
                disabled
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Luogo di nascita</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="comunenascita"
                placeholder="Comune di nascita"
                :value="jsonData.luogoDiNascita"
                style="text-transform: uppercase"
                disabled
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Sesso</strong>
              </div>
              <b-form-select v-if="enabledSesso" class="form-select" v-model="jsonData.sesso" :options="sessoOptions" :disabled="!enabledSesso"> </b-form-select>
              <b-form-select  v-else class="form-select" :value="jsonData.sesso" :options="sessoOptions" :disabled="!enabledSesso"> </b-form-select>
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Stato civile</strong>
              </div>
              <b-form-select class="form-select" v-model="jsonData.statoCivile" :options="statoCivileOptions" :value="null" @change="getStatoCivile"></b-form-select>
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Provincia di residenza</strong>
              </div>
              <b-form-select
                class="form-select"
                v-model="provinciaResidenza"
                :options="provinciaResidenzaOptions"
                :value="null"
                value-field="value"
                text-field="text"
                @change="getSelectedProvinciaResidenza"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Cittadinanza</strong>
              </div>
              <b-form-select class="form-select" v-model="cittadinanzaScelta" :options="cittadinanzaOptions" @change="getSelectedCittadinanza" :value="null" value-field="value" text-field="text"></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong> Comune di residenza</strong>
              </div>
              <b-form-select
                class="form-select"
                v-model="comuneResidenza"
                :value="null"
                value-field="value"
                :options="comuniResidenzaOptions"
                text-field="text"
                style="text-transform: uppercase"
                @change="getSelectedComuneResidenza"
              ></b-form-select>
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Indirizzo di residenza</strong>
              </div>
              <b-form-input type="text" v-model="jsonData.indirizzoResidenza" :value="null" value-field="value" text-field="" style="text-transform: uppercase"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Cellulare</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="provincianascita"
                placeholder="Cellulare"
                value=""
                required
                maxlength="10"
                :state="validationCellulare"
                v-model="jsonData.numeroCellulare"
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Telefono fisso</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="provincianascita"
                placeholder="Telefono fisso"
                value=""
                required
                maxlength="10"
                :state="validationFisso"
                v-model="jsonData.numeroFisso"
              />
            </b-col>
            <b-col v-if="enabledMail" sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Email</strong>
              </div>
              <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="email"
                placeholder="Email"
                value=""
                required
                :state="validationMail"
                v-model="jsonData.email"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-form-checkbox id="checkbox-1" v-model="jsonData.terminiServizio" name="checkbox-1" :value="true" :unchecked-value="false">
              <span class="ml-2">
                Prima di continuare accettare
                <a :href="linkTerminiServizio" target="_blank" class="link-primary fs-6 fw-bolder">termini e condizioni</a></span
              >
            </b-form-checkbox>
          </b-row>
          <b-container class="bv-example-row">
            <b-row>
              <b-col></b-col>
              <b-col
                ><b-button variant="my-5 btn-outline" class="mb-5 ml-21" @click="confermaRegistrazione"><i class="fas fa-clipboard-check"></i> Continua</b-button></b-col
              >
            </b-row>
          </b-container>
        </b-container>
      </div>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import UtilService from "@/services/utilService";
import AuthService from "@/services/authService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";
export default {
  props: {
    accessToken: String,
    jsonData: {
      type: Object,
      default: function () {
        return {
          statoCivile: "",
          idStatoCivile: "",
          descrizioneStatoCivile: "",
          numeroCellulare: "",
          numeroFisso: "",
          email: "",
          provincia: "",
          provinciaResidenza: "",
          comuneResidenza: "",
          codIstatComuneResidenza: "",
          codIstatProvinciaResidenza: "",
          capResidenza: "",
          provinciaResidenzaSigla: "",
          indirizzoResidenza: "",
          luogoDiNascita: "",
          nome: "",
          cognome: "",
          codiceFiscale: "",
          dataNascita: "",
          sesso: "",
          terminiServizio: null,
          scadenzaTS: "",
          codiceTS: "",
          cittadinanza: "",
          istatCittadinanza: "",
        };
      },
    },
    enabledSesso: {
      type: Boolean,
      default: false,
    },
    enabledMail: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      statoCivileOptions: [{ value: null, text: "Seleziona lo stato civile", disabled: true }],
      statoCivile: {
        id: this.jsonData.idStatoCivile,
        descrizione: this.jsonData.descrizioneStatoCivile,
      },
      sessoOptions: [
        { value: "M", text: "MASCHIO" },
        { value: "F", text: "FEMMINA" },
      ],
      provinciaResidenzaOptions: [{ value: null, text: "Seleziona la provincia", disabled: true }],
      provinciaResidenza: {
        provincia: this.jsonData.provinciaResidenza,
        codIstat: this.jsonData.codIstatProvinciaResidenza,
      },
      comuneResidenza: {
        nome: this.jsonData.comuneResidenza,
        codice: this.jsonData.codIstatComuneResidenza,
        cap: this.jsonData.capResidenza,
        provinciaSigla: this.jsonData.provinciaResidenzaSigla,
      },
      cittadinanzaOptions: [{ value: null, text: "Seleziona la cittadinanza", disabled: true }],
      cittadinanzaScelta: {
        descrizione: this.jsonData.cittadinanza,
        istat: this.jsonData.istatCittadinanza,
      },
      comuniResidenzaOptions: [{ value: null, text: "Seleziona il comune", disabled: true }],
      linkTerminiServizio: "https://appsalute.regione.molise.it/ecupt/1.0.0/terminiServizio/display",
      token: null,
      nazionalitaStraniera: false,
      enableSesso: false,
    };
  },
  computed: {
    scadenzaTesseraSanitaria: {
      get() {
        let me = this;
        let scadenzaTessera = Date(me.jsonData.scadenzaTS);
        return moment(scadenzaTessera).format("DD/MM/YYYY");
      },
      set(value) {
        return moment(value).format("DD/MM/YYYY");
      },
    },
    validationCellulare() {
      let regexCellulare = /^3\d{8,9}$/;

      return regexCellulare.test(this.jsonData.numeroCellulare);
    },
    validationFisso() {
      let regexFisso = /^0\d+$/;
      return !this.jsonData.numeroFisso || this.jsonData.numeroFisso.length === 0 ? null : regexFisso.test(this.jsonData.numeroFisso);
    },
    validationMail(){
      let regexMail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return regexMail.test(this.jsonData.email);
    },
  },
  mounted: function () {
    let me = this;
    me.loadListaProvince();
    me.loadStatoCivile();
    me.controlloNazionalita();
    me.getSelectedProvinciaResidenza(me.provinciaResidenza);
  },
  methods: {
    async loadListaProvince() {
      let me = this;
      try {
        const responseProvince = await UtilService.listaProvince();
        responseProvince.data.data.forEach((element) => {
          me.provinciaResidenzaOptions.push({
            value: element,
            text: element.provincia.toUpperCase(),
          });
        });
      } catch (error) {
        error;
      }
    },
    async loadStatoCivile() {
      let me = this;
      try {
        const responseStatoCivile = await UtilService.statoCivile();
        responseStatoCivile.data.data.forEach((element) => {
          me.statoCivileOptions.push({
            value: element,
            text: element.descrizione.toUpperCase(),
          });
        });
      } catch (error) {
        error;
      }
    },
    async getStatoCivile(statoCivile) {
      let me = this;
      me.jsonData.idStatoCivile = statoCivile.id;
      me.jsonData.descrizioneStatoCivile = statoCivile.descrizione;
    },
    async getSelectedProvinciaResidenza(provinciaResidenza) {
      let me = this;
      me.jsonData.provinciaResidenza = provinciaResidenza.provincia;
      me.jsonData.codIstatProvinciaResidenza = provinciaResidenza.codIstat;
      me.comuniResidenzaOptions = [];
      try {
        const responseProvinciResidenza = await UtilService.listaComuni(provinciaResidenza.codIstat.toString());
        if(responseProvinciResidenza.status==401 || responseProvinciResidenza=="Error: Request failed with status code 401"){
          return this.getSelectedProvinciaResidenza(provinciaResidenza)
        }
        if(responseProvinciResidenza)
        if (responseProvinciResidenza) {
          responseProvinciResidenza.data.data.forEach((element) => {
            me.comuniResidenzaOptions.push({
              value: element,
              text: element.nome.toUpperCase(),
            });
          });
        } else {
          me.comuniResidenzaOptions = [{ value: null, text: "Seleziona il comune", disabled: true }];
        }
      } catch (error) {
        console.log("error",error)
        if(error.status && error.status === 401) {
          this.getSelectedProvinciaResidenza(provinciaResidenza)
        }
      }
    },
    getSelectedComuneResidenza(comune) {
      let me = this;
      me.jsonData.comuneResidenza = comune.nome;
      me.jsonData.codIstatComuneResidenza = comune.codice;
      me.jsonData.capResidenza = comune.cap;
      me.jsonData.provinciaResidenzaSigla = comune.provinciaSigla;
    },
    getSelectedCittadinanza(cittadinanza) {
      let me = this;
      me.jsonData.cittadinanza = cittadinanza.descrizione;
      me.jsonData.istatCittadinanza = cittadinanza.istat;
    },
    async controlloNazionalita() {
      let me = this;
      if (me.jsonData.istatCittadinanza !== 100)
        me.nazionalitaStraniera = true;
      try {
        const responseNazioni = await UtilService.listaNazioni();
        responseNazioni.data.data.forEach((element) => {
          me.cittadinanzaOptions.push({
            value: element,
            text: element.descrizione.toUpperCase(),
          });
          me.cittadinanzaOptions.sort(function (a, b) {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
          });
        });
      } catch (error) {
        error;
      }
    },
    async confermaRegistrazione() {
      let me = this;
      const datiRegistrazione = {
        username: "",
        email: me.jsonData.email,
        codiceFiscale: me.jsonData.codiceFiscale,
        codiceTS: "",
        controlloStep2: true,
        nome: me.jsonData.nome,
        cognome: me.jsonData.cognome,
        dataNascita: me.jsonData.dataNascita,
        sesso: me.jsonData.sesso,
        scadenzaTS: "",
        luogoDiNascita: me.jsonData.luogoDiNascita,
        istatLuogoDiNascita: me.jsonData.istatLuogoDiNascita,
        controlloStep1: true,
        statoCivile: me.jsonData.descrizioneStatoCivile,
        codStatoCivile: me.jsonData.idStatoCivile,
        provinciaResidenza: me.jsonData.provinciaResidenza,
        codIstatProvinciaResidenza: me.jsonData.codIstatProvinciaResidenza,
        comuneResidenza: me.jsonData.comuneResidenza,
        codIstatComuneResidenza: me.jsonData.codIstatComuneResidenza,
        provinciaResidenzaSigla: me.jsonData.provinciaResidenzaSigla,
        strutturaPreferita: "140000",
        istatCittadinanza: me.cittadinanzaScelta.istat, //me.jsonData.codiceFiscale.substr(11, 1) === "Z" ? me.cittadinanzaScelta.istatCittadinanza : me.jsonData.istatCittadinanza,
        indirizzoResidenza: me.jsonData.indirizzoResidenza,
        capResidenza: me.jsonData.capResidenza,
        cittadinanza: me.cittadinanzaScelta.descrizione, //me.jsonData.codiceFiscale.substr(11, 1) === "Z" ? me.cittadinanzaScelta.cittadinanza: "ITALIA",
        terminiServizio: me.jsonData.terminiServizio,
        numeroCellulare: me.jsonData.numeroCellulare,
        numeroFisso: me.jsonData.numeroFisso,
        codiceNazionalita: me.jsonData.istatCittadinanza,
      };
      const checkCampiMancanti = me.campiMancanti(datiRegistrazione);
      if (checkCampiMancanti.err) {

          let msg = getVocabolario("campiMancanti")
          if(!msg)
              msg = "Campi Mancanti.\n"
        return this.$bvModal
          .msgBoxOk(msg + checkCampiMancanti.data, {
            title: "Attenzione",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-warning",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch((error) => {
            me.isLoading = false;
            me.$bvModal
              .msgBoxOk(error, {
                title: "Errore",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {})
              .catch(() => {});
          });
      } else {
        try {
          const responseRegistrazione = await AuthService.registrazione(datiRegistrazione,this.accessToken);
          console.log(responseRegistrazione);
          if (responseRegistrazione.data.stato === 201) {
            me.$emit("accedi");
          } else {
              let msg = getVocabolario("errorAccesso")
              if(!msg)
                  msg = "Accesso non avvenuto. Controlla i dati inseriti."
            this.$bvModal
              .msgBoxOk(msg, {
                title: "Attenzione",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-warning",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {})
              .catch((error) => {
                me.isLoading = false;
                me.$bvModal
                  .msgBoxOk(error, {
                    title: "Errore",
                    size: "md",
                    okVariant: "outline-danger",
                    headerClass: "vv-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {})
                  .catch(() => {});
              });
          }
        } catch (error) {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch(() => {});
        }
      }
    },
    onIndietro() {
      let me = this;
      me.$emit("setStep", 0);
    },
    campiMancanti(datiRegistrazione) {
      for (let key in datiRegistrazione) {
        if (key === "username" || key === "codiceTS" || key === "scadenzaTS" || key === "numeroFisso") continue;
        else if (!datiRegistrazione[key]) {
          return {err: true, data: key + ' = ' + datiRegistrazione[key]};
        }
      }
      return { err: false, data: null };
    },
  },
};
</script>

<style></style>
